import { useCallback, useEffect, useMemo, useState } from 'react';
import Grid from '@mui/material/Grid';
import LocalizedStrings from 'react-localization';
import LOCALIZATIONS from './localizations';
import { useSelector } from 'react-redux';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import NFT from '../../../components/NFT';
import './style.css';
import { getWalletTokens } from '../../../util/metamask';
import { CollectionIcon, HistoryIcon } from '../../../util/icons';
import SearchIcon from '@mui/icons-material/Search';
import { PATH_VIEW, PATH_HISTORY } from '../../config';
import Billboard from '../../../components/Billboard';
import Page from '../../../components/Page';
import PageTitle from '../../../components/PageTitle';
import MetaMaskIcon from '../../../components/MetaMaskIcon';

const Collection = () => {

    const labels = useMemo(() => new LocalizedStrings( LOCALIZATIONS ), []),
    locale = useSelector( state => state.app.locale ),
    accounts = useSelector( state => state.eth.accounts ),
    [ NFTs, setNFTs ] = useState( null ),
    menu = [
        {
            icon: <SearchIcon />,
            label: labels.viewBoard,
            to: PATH_VIEW
        },
        {
            icon: <HistoryIcon />,
            label: labels.tokenHistory,
            to: PATH_HISTORY
        }
    ];

    /**
     * @name getNFTs
     * @function
     * @description Gets user's list of NFTs
     */
    const getNFTs = useCallback( async () => {
        const tokens = await getWalletTokens();
        setNFTs( tokens );
    }, [ setNFTs ]);

    // update locale
    useEffect(() => {
        if( locale !== labels.getLanguage() ) labels.setLanguage( locale );
    }, [ labels, locale ]);

    // update connected status
    useEffect(() => {
        if( accounts[ 0 ] ) getNFTs();
    }, [ accounts, getNFTs ])
   
    return (
        <Page modifer="collection" title={ labels.title }>
            <PageTitle 
                Icon={ CollectionIcon }
                title={ labels.title }
                subtitle={
                    labels.formatString(
                        labels.subtitle,
                        <strong>{ accounts[ 0 ] }</strong>
                    )
                } />
            <Grid container justifyContent="center">
                {
                    !NFTs ?
                        <Grid item xs={ 12 }>
                            <div className="coe__collection__noData">
                                {
                                    !window.ethereum || accounts.length === 0 ?
                                        <Billboard alignItems="center" body={ labels.notConnectedBody } title={ labels.notConnectedTitle } Icon={ MetaMaskIcon } /> :
                                        <Billboard alignItems="center" body={ labels.noDataBody } title={ labels.noDataTitle } Icon={ LinkOffIcon } />
                                }
                            </div>
                        </Grid> :
                        NFTs?.map(
                            token => (
                                <Grid item key={ token } md={ 4 } sm={ 6 } xs={ 12 }>
                                    <NFT id={ token } menu={ menu } /> 
                                </Grid>
                            )
                        )
                }
            </Grid>
        </Page>
    )

}

export default Collection;